import type { ModuleGate } from '@/shell/model/module-catalog';
import {
  EXPENSES_APPROVE,
  EXPENSES_MANAGE,
  EXPENSES_READ_ALL,
  EXPENSES_REPORT_READ,
  EXPENSES_SUBMIT,
} from './use-expenses-permissions';

/**
 * Who sees «Note spese»: the ONE place the rule lives, read by the rail entry and by the route
 * gate. A Richiedente holds `submit`; Gestione and Approvatore hold `read-all` (decision 131); the
 * Revisore holds `report:read` only (release 2, §1.8).
 */
export const EXPENSES_GATE: ModuleGate = {
  kind: 'permission',
  anyOf: [EXPENSES_SUBMIT, EXPENSES_READ_ALL, EXPENSES_REPORT_READ],
};

/** The expense list and the capture screens: not for the Revisore (spec §1.8). */
export const EXPENSES_ENTRY_GATE: ModuleGate = {
  kind: 'permission',
  anyOf: [EXPENSES_SUBMIT, EXPENSES_READ_ALL],
};

/** «Chiusure»: Gestione, an Approvatore, whoever reads everything, and the Revisore. */
export const EXPENSES_CLOSINGS_GATE: ModuleGate = {
  kind: 'permission',
  anyOf: [EXPENSES_MANAGE, EXPENSES_APPROVE, EXPENSES_READ_ALL, EXPENSES_REPORT_READ],
};

/** Gestione only: the mileage settings (the €/km rule). */
export const EXPENSES_MANAGE_GATE: ModuleGate = {
  kind: 'permission',
  anyOf: [EXPENSES_MANAGE],
};
